module.exports = __webpack_public_path__ + "media/images/desktop/white_phone-a061709ed27357c2ddd0c20a3cd81180.png";